import * as types from "./actionTypes";
import * as config from "../../../config";
const {getActionsForUser, createActionUserEngagement} = require("@carbonclick/carbon-api-client/src/api/reduceApi");
import { extractApiError } from '../../util/errorExtractor'
import { beginApiCall } from "./apiStatusActions";
import { errorHandlerActions } from './errorHandlerActions';

function getActionsSuccess(reduceActions) {
  return { type: types.GET_REDUCE_ACTIONS_SUCCESS, reduceActions };
}

function getActionsFail(error) {
  return { type:types.GET_REDUCE_ACTIONS_FAILED, error };
}
export function getReduceActionsForUser(email) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return getActionsForUser(email)
      .then(data => {
        dispatch(getActionsSuccess(data));
      })
      .catch(error => {
        const status = extractApiError(error).status;
        const sentryMessage = `${config.deployment_env} reduceActionsActions.js: get reduce actions for ${email} api call error ${JSON.stringify(extractApiError(error))}`;
        dispatch(errorHandlerActions(status, sentryMessage, "fatal"));
        dispatch(getActionsFail(error));
      });
  };
}


export function createReduceActionsUserEngagement({email,actionId,type}) {
  const eventData = {email,actionId,type};
  return function (dispatch) {
    if(type!='VIEWED'){
      dispatch({type:types.CREATE_REDUCE_ACTION_USER_ENGAGEMENT_SUCCESS, engagement:eventData });
    }
    return createActionUserEngagement(eventData)
      .then(() => {
        // console.log('API created reduce action engagement: '+eventData)
      })
      .catch(error => {
        const status = extractApiError(error).status;
        const sentryMessage = `${config.deployment_env} reduceActionsActions.js: create reduce action engagement for ${email} ${type} ${actionId} api call error ${JSON.stringify(extractApiError(error))}`;
        dispatch(errorHandlerActions(status, sentryMessage, "fatal"));
        if(type!='VIEWED'){
          dispatch({ type:types.CREATE_REDUCE_ACTION_USER_ENGAGEMENT_FAILED, error, actionId });
        }
      });
  };
}
